import { BackupEmpresaService } from './../../services/backup-empresa.service';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Empresa, TIPO_EMPRESAS } from 'src/app/model/empresa';
import { BackendApiService } from 'src/app/services/backend-api.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { Router, Route } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-section-empresas',
  templateUrl: './section-empresas.component.html',
  styleUrls: ['./section-empresas.component.scss'],
})
export class SectionEmpresasComponent implements OnInit {

  @Input() tipo: TIPO_EMPRESAS = TIPO_EMPRESAS.PRE_INCUBADA;

  public arrSub: Array<Subscription> = new Array();

  arrEmpresasIncubadas = new Array()
  arrGraduada = new Array()
  arrMantenedora = new Array()

  titulo = ''

  url_base = environment.backend.base_url;
  project_name = environment.backend.project_suffix;

  hasError = false;
  loading = false;
  arrEmpresas!: Empresa[];

  constructor(private backendApiService: BackendApiService, public routes: Router, public backup: BackupEmpresaService) { }

  reset(): void {
    this.hasError = false;
    this.loading = false;
  }

  getTitulo(): string {
    switch (true) {
      case this.tipo === TIPO_EMPRESAS.PARCEIRA:
        return 'Empresas Parceiras';
      case this.tipo === TIPO_EMPRESAS.MANTENEDORA:
        return 'Empresas Mantenedoras';
      case this.tipo === TIPO_EMPRESAS.GRADUADA:
        return 'Empresas Graduadas';
      case this.tipo === TIPO_EMPRESAS.PRE_INCUBADA:
        return 'Empreendimentos Pré-incubados';
      case this.tipo === TIPO_EMPRESAS.INCUBADA:
        return 'Empresas Incubadas';
      default:
        return '';
    }
  }

  filter = (filter: string) => {
    return `?limit=100&sort=tipo&where=(ativo,eq,true)~and${filter}`
  }

  findEmpresaAllMantenedora() {
    let sub = this.backendApiService.findAllEmpresa<Empresa>('mantenedora').subscribe({
      next: (res) => {
        this.arrMantenedora = res.filter((res: Empresa) => res)
        this.hasError = false;
      },
      error: (err) => {
        this.loading = false;
        console.log(err)
        // this.hasError = true;
        this.arrMantenedora = this.backup.EmpresaMantenedora()
      },
      complete: () => {
        this.loading = false
      }
    })

    this.arrSub.push(sub)
  }

  findEmpresaAllGraduada() {
    let sub = this.backendApiService.
      findAllEmpresa<Empresa>('graduada').subscribe({
        next: (res) => {
          this.arrGraduada = res.filter((res: Empresa) => res)
          this.hasError = false;
        },
        error: (err) => {
          this.loading = false;
          console.log(err)
          // this.hasError = true;
          this.arrGraduada = this.backup.EmpresaGraduada()
        },
        complete: () => {
          this.loading = false
        }
      })
    this.arrSub.push(sub)
  }

  findEmpresasAllIncubadas() {
    let sub = this.backendApiService.
      findAllEmpresa<Empresa>('incubada').
      subscribe({
        next: (res) => {
          this.arrEmpresasIncubadas = res.filter((res: Empresa) => res)
          this.hasError = false;
        },
        error: (err) => {
          this.loading = false;
          console.log(err)
          // this.hasError = true;
          this.arrEmpresasIncubadas = this.backup.EmpresaIncubada();
        },
        complete: () => {
          this.loading = false
        }
      })

    this.arrSub.push(sub)
  }

  ngOnInit(): void {
    this.reset();
    this.loading = true;

    if (!this.tipo) {
      this.loading = false;
      this.hasError = true;
    }

    this.arrSub.push(
      this.backendApiService.findAllEmpresa<Empresa>(this.tipo).subscribe({
        next: (data: Array<Empresa>) => {
          //success
          this.arrEmpresas = data;
          this.hasError = false;
        },
        error: (error: any) => {
          this.loading = false;
          this.hasError = true;
        },
        complete: () => {
          this.loading = false;
        },
      })
    );

    $('[data-toggle="tooltip"]').tooltip('hide');
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
    }, 1000);
  }


  // ngOnInit(): void {

  //   console.log(this.routes.url)

  //   this.reset();
  //   this.loading = true;
  //   this.findEmpresaAllMantenedora()
  //   this.findEmpresaAllGraduada()
  //   this.findEmpresasAllIncubadas()


  //   $('[data-toggle="tooltip"]').tooltip('hide');
  //   setTimeout(() => {
  //     $('[data-toggle="tooltip"]').tooltip();
  //   }, 1000);
  // }

  @HostListener('window:beforeunload')
  async ngOnDestroy() {
    this.arrSub.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
